import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink, Table, Spinner, Button } from "reactstrap";
import classnames from "classnames";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Label as YLabel,
} from "recharts";
import axios from "axios";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

import * as XLSX from "xlsx";
const MonthReport = ({
  machine,
  part,
  month,
  qualityTab,
  setQualityTab,
}) => {
  const [monthData, setMonthData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!machine || !month) return;

    fetchMonthlyProduction();
  }, [machine, part, month]);

  const fetchMonthlyProduction = async () => {
    try {
      setLoading(true);

      const [year, monthNum] = month.split("-");

      const res = await axios.get(
        "https://api.hanoch.in/api/mcc-monthly-production/",
        {
          params: {
            machine_id: machine,
            partname: part || null,
            year,
            month: Number(monthNum),
          },
        }
      );

      const apiData = res.data || {};

      const transformed = Object.entries(apiData).map(
        ([day, values]) => ({
          day,
          good: values?.good ?? 0,
          bad: values?.bad ?? 0,
        })
      );

      setMonthData(transformed);
    } catch (err) {
      console.error("Monthly production error:", err);
    } finally {
      setLoading(false);
    }
  };
 const exportToExcel = () => {
    if (!monthData.length) return;

    const rows = monthData.map((row) => ({
      Day: row.day,
      ...(qualityTab !== "BAD" && { Good: row.good }),
      ...(qualityTab !== "GOOD" && { Bad: row.bad }),
    }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Monthly Production");

    XLSX.writeFile(
      wb,
      `Monthly_Production_${month}_${qualityTab}.xlsx`
    );
  };
  const totalGood = monthData.reduce((sum, d) => sum + d.good, 0);
const totalBad = monthData.reduce((sum, d) => sum + d.bad, 0);
const totalProduction = totalGood + totalBad;

  return (
    <>
    {!loading && (
  <Row className="mb-4">
    <Col md="4">
      <Card
       className="text-center shadow border border-secondary"
            style={{ backgroundColor: "rgb(37, 43, 59);", color: "#252231" }}>
        <CardBody>
          <CardTitle tag="h6" className="text-success">
            Good
          </CardTitle>
          <h3 className="fw-bold">{totalGood}</h3>
        </CardBody>
      </Card>
    </Col>

    <Col md="4">
      <Card className="text-center shadow border border-secondary"
            style={{ backgroundColor: "rgb(37, 43, 59);", color: "#252231" }}>
        <CardBody>
          <CardTitle tag="h6" className="text-danger">
            Bad
          </CardTitle>
          <h3 className="fw-bold">{totalBad}</h3>
        </CardBody>
      </Card>
    </Col>

    <Col md="4">
      <Card  className="text-center shadow border border-secondary"
            style={{ backgroundColor: "rgb(37, 43, 59);", color: "#252231" }}>
        <CardBody>
          <CardTitle tag="h6" className="text-primary">
            Total
          </CardTitle>
          <h3 className="fw-bold">{totalProduction}</h3>
        </CardBody>
      </Card>
    </Col>
  </Row>
)}

      {/* QUALITY TABS */}
      <Nav pills className="mb-3 justify-content-center">
        {["ALL", "GOOD", "BAD"].map((tab) => (
          <NavItem key={tab}>
            <NavLink
              className={classnames({ active: qualityTab === tab })}
              onClick={() => setQualityTab(tab)}
              style={{ cursor: "pointer" }}
            >
              {tab === "ALL"
                ? "All Products"
                : tab === "GOOD"
                ? "Good Products"
                : "Bad Products"}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      {/* LOADING */}
      {loading && (
        <div className="text-center my-4">
          <Spinner size="sm" />
        </div>
      )}

      {/* CHART */}
      {!loading && (
        <div style={{ width: "100%", height: 320 }}>
          <ResponsiveContainer>
            <BarChart data={monthData} barSize={20}>
              <XAxis
                dataKey="day"
                label={{ value: "Day", position: "insideBottom", offset: -5 }}
              />
              <YAxis>
                <YLabel
                  value={
                    qualityTab === "ALL"
                      ? "Quantity"
                      : qualityTab === "GOOD"
                      ? "Good Quantity"
                      : "Bad Quantity"
                  }
                  angle={-90}
                  position="insideLeft"
                />
              </YAxis>

              <Tooltip />
              <Legend />

              {qualityTab === "ALL" && (
                <>
                  <Bar
                    dataKey="good"
                    fill="#5ca56d"
                    name="Good Products"
                  />
                  <Bar
                    dataKey="bad"
                    fill="#90303a"
                    name="Bad Products"
                  />
                </>
              )}

              {qualityTab === "GOOD" && (
                <Bar
                  dataKey="good"
                  fill="#5ca56d"
                  name="Good Products"
                />
              )}

              {qualityTab === "BAD" && (
                <Bar
                  dataKey="bad"
                  fill="#90303a"
                  name="Bad Products"
                />
              )}
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* TABLE */}
      {!loading && (
        <>
          <div className="d-flex justify-content-end mt-3">
        <Button
          color="success"
          size="sm"
          onClick={exportToExcel}
          disabled={!monthData.length}
        >
          Export Excel
        </Button>
      </div>
        <Table bordered responsive className="mt-4">
          <thead>
            <tr>
              <th>Day</th>
              {qualityTab !== "BAD" && <th>Good Qty</th>}
              {qualityTab !== "GOOD" && <th>Bad Qty</th>}
            </tr>
          </thead>
          <tbody>
            {monthData.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center">
                  No data available
                </td>
              </tr>
            )}

            {monthData.map((row, idx) => (
              <tr key={idx}>
                <td>{row.day}</td>
                {qualityTab !== "BAD" && <td>{row.good}</td>}
                {qualityTab !== "GOOD" && <td>{row.bad}</td>}
              </tr>
            ))}
          </tbody>
        </Table>
        </>
      )}
    </>
  );
};

export default MonthReport;
